import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { Badge } from '../../../../components/ui';

const ApprovalTemplateStatusSection = ({ selectedRecord }) => {
  const { theme } = useTheme();

  return (
    <>
      {/* Status Header */}
      <div className={cn("p-3 rounded-lg border", theme.colors.surface, theme.border.light)}>
        <div className="flex items-center justify-between mb-3">
          <h2 className={cn("text-lg font-bold", theme.text.primary)}>
            {selectedRecord.name}
          </h2>
          <Badge 
            variant={selectedRecord.isActive ? 'success' : 'secondary'}
            className="text-xs"
          >
            {selectedRecord.isActive ? 'Active' : 'Inactive'}
          </Badge>
        </div>
        
        <div className="flex flex-wrap items-center gap-2 mb-2">
          {selectedRecord.priority && (
            <Badge 
              variant={selectedRecord.priority === 'high' ? 'destructive' : 
                     selectedRecord.priority === 'medium' ? 'warning' : 'secondary'}
              className="text-xs"
            >
              {(selectedRecord.priority?.name || selectedRecord.priority)?.charAt(0).toUpperCase() + (selectedRecord.priority?.name || selectedRecord.priority)?.slice(1)} Priority
            </Badge>
          )}
          {selectedRecord.approvalType && (
            <Badge variant="outline" className="text-xs">
              {(selectedRecord.approvalType?.charAt(0).toUpperCase() + selectedRecord.approvalType?.replace('_', ' ')?.slice(1))}
            </Badge>
          )}
        </div>
        
        {selectedRecord.description && (
          <p className={cn("text-sm mt-2", theme.text.secondary)}>
            {selectedRecord.description}
          </p>
        )}
      </div>

      {/* Key Information */}
      <div className="space-y-3 mt-4">
        {selectedRecord.entityType && (
          <div className={cn("flex items-center justify-between p-3 rounded-lg", theme.colors.background, theme.border.subtle)}>
            <div className="flex items-center space-x-3">
              <span className={cn("text-sm font-medium", theme.text.secondary)}>Entity Type</span>
            </div>
            <Badge variant="outline">
              {selectedRecord.entityType?.name?.charAt(0).toUpperCase() + selectedRecord.entityType?.name?.slice(1)}
            </Badge>
          </div>
        )}

        {selectedRecord.workflowType && (
          <div className={cn("flex items-center justify-between p-3 rounded-lg", theme.colors.background, theme.border.subtle)}>
            <div className="flex items-center space-x-3">
              <span className={cn("text-sm font-medium", theme.text.secondary)}>Workflow</span>
            </div>
            <Badge variant="outline">
              {selectedRecord.workflowType === 'review' ? 'Review Only' :
               selectedRecord.workflowType === 'approval' ? 'Approval Only' :
               selectedRecord.workflowType === 'review_approval' ? 'Review & Approval' :
               'Standard'}
            </Badge>
          </div>
        )}

        {selectedRecord.steps && selectedRecord.steps.length > 0 && (
          <div className={cn("flex items-center justify-between p-3 rounded-lg", theme.colors.background, theme.border.subtle)}>
            <div className="flex items-center space-x-3">
              <span className={cn("text-sm font-medium", theme.text.secondary)}>Steps</span>
            </div>
            <span className={cn("text-sm font-semibold", theme.text.primary)}>
              {selectedRecord.steps.length} step{selectedRecord.steps.length !== 1 ? 's' : ''}
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default ApprovalTemplateStatusSection;

